<template>
    <footer>
        <!-- footer content begin -->

        <div class="uk-section uk-background-secondary uk-light">
            <div class="uk-container uk-text-small">
                <div class="uk-child-width-1-2@m" data-uk-grid>
                    <div class="in-footer-logo">
                        <RouterLink @click.native="scrollToTop" class="text-decoration-none"
                                    :to="{ name: 'landing-page' }">
                            <h3 class="text-primary-color mb-2">
                                <img style="height: 80px; width: 250px"
                                     src="../../../assets/images/logo/logo2.png" class="pt-1 mt-1 img-fluid" alt="">
                            </h3>
                        </RouterLink>
                    </div>
                    <div class="uk-flex uk-flex-right@m">
                        <div class="in-footer-socials">
                            <a href="https://wa.me/15551234567" target="_blank"><i class="fab fa-whatsapp"></i></a>
                            <a href="mailto:info@traderista-trading.com" target="_blank"><i class="fas fa-envelope"></i></a>
                            <a href="https://www.instagram.com/traderista/" target="_blank"><i
                                class="fab fa-instagram"></i></a>
                            <a href="https://facebook.com/Traderista-104665101894659/" target="_blank"><i
                                class="fab fa-facebook"></i></a>
                            <a href="https://med.etoro.com/B19351_A87376_TClick.aspx"
                               class="ml-3" target="_blank">
                                <img style="margin-top: -5px" height="18" width="20.5" src="../../../assets/img/website/etoro.png"></a>
                        </div>
                    </div>
                </div>
                <div class="uk-child-width-1-2@s uk-child-width-1-4@m " data-uk-grid>
                    <div>
                        <h3>{{ $t('navbar.blog') }}</h3>
                        <ul class="uk-list uk-link-text  font-15">
                            <li>
                                <RouterLink @click.native="scrollToTop" :to="{ name: 'blog-page' }">
                                    {{ $t('navbar.goToBlog') }}
                                </RouterLink>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h3>Plattform</h3>
                        <ul class="uk-list uk-link-text  font-15">
                            <li>
                                <RouterLink @click.native="scrollToTop" :to="{ name: 'partner-page' }">
                                    {{ $t('navbar.start') }}
                                </RouterLink>
                            </li>
                            <li>
                                <RouterLink @click.native="scrollToTop" :to="{ name: 'pricing-page' }">
                                    {{ $t('navbar.products') }}
                                </RouterLink>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h3>Firma</h3>
                        <ul class="uk-list uk-link-text font-15">
                            <li>
                                <RouterLink @click.native="scrollToTop" :to="{ name: 'our-mission-page' }"><p>
                                    {{ $t('navbar.ourMission') }}</p></RouterLink>
                            </li>
                            <li>
                                <RouterLink @click.native="scrollToTop" :to="{ name: 'agb-page' }">{{
                                        $t('navbar.agb')
                                    }}
                                </RouterLink>
                            </li>
                            <li>
                                <RouterLink @click.native="scrollToTop" :to="{ name: 'impressum' }"><p>Impressum</p>
                                </RouterLink>
                            </li>
                            <li>
                                <RouterLink @click.native="scrollToTop" :to="{ name: 'contact' }"><p>
                                    {{ $t('navbar.contact') }}</p></RouterLink>
                            </li>
                        </ul>
                    </div>
                    <RouterLink :to="{ name: 'our-mission-page' }">
                        <div class="hubertus-image-footer align-content-center text-center">
                            <ul class="uk-list uk-link-text  font-15">
                                <img src="../../../assets/img/website/hubertus.png"
                                     style="border-radius: 15px;"
                                     alt="image-team"
                                     width="250">
                            </ul>
                        </div>
                    </RouterLink>
                </div>
            </div>
        </div>
        <!-- footer content end -->
        <!-- totop begin -->
        <div class="uk-visible@m">
            <a href="#" class="in-totop fas fa-chevron-up" data-uk-scroll></a>
        </div>
        <!-- totop end -->
    </footer>
</template>

<script>
export default {
    name: "website-footer",
    methods: {
        scrollToTop() {
            setTimeout(function () {
                window.scrollTo(0, 0)
            }, 25)
        }
    }
}
</script>

<style scoped>

</style>
